module.exports = __webpack_public_path__ + "img/wechat.f69396f8.png";